import type { ReactNode } from 'react';

interface SurfaceProps {
  children: ReactNode;
  className?: string;
  id?: string;
  glow?: 'gold' | 'cyan' | 'pink' | 'none';
}

const glowClass = {
  gold: 'hover:border-fiesta-yellow/40 hover:shadow-[0_0_40px_-18px_rgba(245,197,24,0.55)]',
  cyan: 'hover:border-fiesta-blue/40 hover:shadow-[0_0_40px_-18px_rgba(62,224,255,0.45)]',
  pink: 'hover:border-fiesta-pink/40 hover:shadow-[0_0_40px_-18px_rgba(255,77,184,0.4)]',
  none: '',
};

export function Surface({ children, className = '', id, glow = 'none' }: SurfaceProps) {
  return (
    <div
      id={id}
      className={`rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur-sm transition-all duration-300 ${glowClass[glow]} ${className}`}
    >
      {children}
    </div>
  );
}
